<article>
  <span>
    <i class="mdi mdi-magnify"></i>
    <input class="fourd" type="text" placeholder="Search" [(ngModel)]="searchText" (keyup)="searchChanged()" title="{{ tooltipText }}" tooltipPosition="bottom" />
    @if (resultCount() === 0) {
      <div class="no-results">
        <app-chip [isDanger]="true" [canClick]="false" label=" No results" />
      </div>
    }
  </span>
</article>
